export default {
  "navbar": {
    "home": "Home",
    "region": "A Região",
    "territory": "Território e Café",
    "governance": "Governança",
    "news": "Notícias",
    "contact": "Contato",
    "associates": "Associados"
  }
}
